import BaseService from "./BaseService";
import { API_BASE_URL_ENV } from "../jsx/common/common";
import http from "./HttpService";

const apiEndpoint = API_BASE_URL_ENV() + "/vender/myBookings";
const apiStatusEndpoint = API_BASE_URL_ENV() + "/vender/myBookings/status";

export default class VendorBookingService extends BaseService {
	constructor() {
		super(apiEndpoint);
	}
	toggleStatus = (id, data) => {
		return http.put(`${apiStatusEndpoint}/${id}`, data);
	};
}
